import { memo, Fragment } from "react";
import { ListSelectionProvider } from "~/pages/dashboard/task/ui/list-selection-context";
import type { Item, Task } from "~/types/api";
import type { StatusGroup, TabWindow } from "../task.types";
import { ItemDetailView } from "./detail-view/item-detail-window";
import { TaskExplorerContainer } from "./task-explorer/task-explorer-container";

type Props = {
  window: TabWindow<StatusGroup>;
  tasks?: Task[];
  showDetailView: boolean;
  detailViewItem: Item[] | null;
  isLoadingDetailView: boolean;
  onCloseDetailView: () => void;
};

export const WindowRenderer = memo<Props>(
  ({
    window,
    showDetailView,
    detailViewItem,
    isLoadingDetailView = false,
    onCloseDetailView,
    tasks,
  }) => {
    return (
      <Fragment key={window.id}>
        <ListSelectionProvider>
          <TaskExplorerContainer window={window} />
          {showDetailView && (
            <ItemDetailView
              selectedItems={detailViewItem ?? []}
              isLoading={isLoadingDetailView}
              onClose={onCloseDetailView}
              window={window}
              tasks={tasks}
            />
          )}
        </ListSelectionProvider>
      </Fragment>
    );
  }
);

WindowRenderer.displayName = "WindowRenderer";
